// The anonymous player id lives in an HttpOnly cookie set by the Worker and
// is mirrored here so a purged cookie can be recovered (Player Accounts).
const KEY = 'wits.playerId';

export function storedPlayerId(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function rememberPlayerId(id: string): void {
  try {
    localStorage.setItem(KEY, id);
  } catch {
    // Private mode or blocked storage: the cookie alone carries the id.
  }
}
